(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoDemarcacaoCtrl', HistoricoDemarcacaoCtrl);

  HistoricoDemarcacaoCtrl.$inject = [
    '$scope',
    'LoadingService',
    '$routeParams',
    'AtividadesService',
    'DrawPolygonsService',
    'OperacoesService',
    'MaquinasService',
    'ItensService',
    '$q',
    'filterFilter',
    'MessagesService',
    'ColorService',
    'DrawPolygonsObjectService',
    '$filter',
    'LeafletService',
    '$route',
    '$uibModal',
    'TrackingService',
    'MapaService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function HistoricoDemarcacaoCtrl($scope, LoadingService, $routeParams,
    AtividadesService, DrawPolygonsService, OperacoesService,
    MaquinasService, ItensService, $q,
    filterFilter, MessagesService, ColorService,
    DrawPolygonsObjectService, $filter, LeafletService,
    $route, $uibModal, TrackingService, MapaService) {
    const COLOR_SELECTED_ICON = '#FFFFFF';
    const vm = this;
    let hasPage = true;
    let inProgress = false;

    //////////////////////////////////////////
    // Controller data
    vm.initialized = false;
    vm.filters = {
      page: 1
    };
    vm.keep = false;
    vm.glebas = [];
    vm.currentGleba = null;
    vm.zoomGleba = null;
    vm.atividades = [];
    vm.tipos = [];
    vm.cultivares = [];
    vm.operacoes = [];
    vm.maquinas = [];
    vm.drawPolygons = [];
    vm.loadingCultivares = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.getPolygons = getPolygons;
    vm.setFilterAttribute = setFilterAttribute;
    vm.setAtividade = setAtividade;
    vm.openDrawPolygonDetails = openDrawPolygonDetails;
    vm.goToNew = goToNew;
    vm.edit = edit;
    vm.openUsosMaquina = openUsosMaquina;
    vm.toggleCarregarAutomaticamente = toggleCarregarAutomaticamente;
    vm.createPopup = createPopup;
    vm.resetMarkers = resetMarkers;

    //////////////////////////////////////////
    // Function declarations

    function initializeVariables() {
      hasPage = true;
      inProgress = false;
      vm.drawPolygons = [];
      vm.filters.page = 1;
      vm.currentGleba = null;
      $scope.$emit('setPolygons', []);
      $scope.$emit('setZoomGlebas', null);
    }

    function resetVariables() {
      initializeVariables();
      vm.filters = {
        page: 1
      };
      vm.initialized = false;

      vm.glebas = $scope.$root.currentPropriedade.glebas || [];
      vm.currentGleba = $routeParams.gleba || null;
      vm.zoomGleba = vm.currentGleba;
      vm.atividades = [];
      vm.cultivares = [];
      vm.operacoes = [];
      vm.maquinas = [];
      vm.drawPolygon = [];
    }

    function reset(variables = true) {
      if (vm.keep) {
        return;
      }

      $scope.$emit('setPolygons', []);
      $scope.$emit('setPolylines', []);
      if (variables) {
        resetVariables();
      }
    }

    function loadCultivares() {
      return ItensService.listCultivares({
        atividade: (vm.filters.atividade || {}).id || null
      }).then(function(result) {
        vm.cultivares = result.data;
      });
    }

    function getPolygons() {
      const hasFilterPage = vm.filters && vm.filters.page;
      if (hasFilterPage && hasPage && !inProgress) {
        LoadingService.showLoading();
        inProgress = true;

        DrawPolygonsService.list(vm.filters).then((data) => {
          const dados = data.data || [];
          hasPage = (((data.pages || {}).pagination || {}).next || 0) > vm.filters.page;

          if (dados.length) {
            vm.filters.page++;
            dados.forEach((item) => {
              item.color = item.cor || ColorService.getRandom();
              item.linkKml = DrawPolygonsService.getLinkKml(item.id, $scope.$root.currentUser.token);
              if ($routeParams.activeDrawPolygon && Number($routeParams.activeDrawPolygon) === Number(item.id)) {
                openDrawPolygonDetails(null, item);
              }
            });
            vm.drawPolygons = vm.drawPolygons.concat(dados);
          }
        })
          .catch(getPolygonsError)
          .finally(() => {
            inProgress = false;
            LoadingService.hideLoading();
          });
      }
    }

    function getPolygonsError(err) {
      console.error(err);
      MessagesService.alert('Não foi possível buscar a lista de Áreas Demarcadas.');
    }

    /**
     * Sets filter attribute based on selected option
     *
     * @param {string} attribute attribute to be set
     * @param {any} object object with value
     * @param {Event} event click event
     */
    function setFilterAttribute(attribute, object, event = null) {
      if (event) {
        event.preventDefault();
      }
      initializeVariables();
      vm.filters[attribute] = object;
      vm.getPolygons();
    }

    /**
     * Sets new atividade filter
     *
     * @param {any} atividade atividade data object
     * @param {Event} event click event
     */
    function setAtividade(atividade, event) {
      event.preventDefault();
      initializeVariables();
      vm.filters.atividade = atividade;
      vm.loadingCultivares = true;
      loadCultivares().finally(() => vm.loadingCultivares = false);
      vm.getPolygons();
    }

    /**
     * Show details and draws polygons on map
     *
     * @param {Event} event click event
     * @param {any} drawPolygon drawPolygon object with data
     */
    function openDrawPolygonDetails(event, drawPolygon) {
      if (drawPolygon.loading) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (!drawPolygon.open) {
        $route.updateParams({
          activeDrawPolygon: drawPolygon.id
        });
        loadPolygonData(drawPolygon).then(processLoadedPolygons)
          .catch((error) => {
            console.error(error);
            MessagesService.alert('Não foi possível consultar a área demarcada.');
          })
          .finally(() => {
            drawPolygon.loading = false;
            drawPolygon.open = !drawPolygon.open;
            drawPolygon.background = drawPolygon.color;
            drawPolygon.color = COLOR_SELECTED_ICON;
          });
      } else {
        hidePolygons(drawPolygon);
      }
    }

    function processLoadedPolygons(drawPolygon) {
      const map = LeafletService.getMap('propriedade-map');
      vm.markers = vm.markers || [];
      $scope.$emit('clearMarkers');

      drawPolygon.allData.polygons.forEach((polygon) => {
        polygon.descricao = formatDescricaoHtml(drawPolygon);

        if (drawPolygon.tipo.id !== 'plantio_operador') {
          L.Util.setOptions(polygon, {
            color: drawPolygon.color
          });
        }

        if (drawPolygon.tipo.id === 'campo_de_producao' && drawPolygon.relacao_campo.coordenadas) {
          addMarker(drawPolygon, map);
        }

        const tooltip = L.tooltip();
        tooltip.setContent(generateTooltipContent(polygon));
        polygon.bindTooltip(tooltip);

        if (polygon.coordinate && !polygon.coordinate.length > 0) {
          addPolygonPopup(polygon);
        }
      });

      $scope.$emit('addPolygons', drawPolygon.allData.polygons);
      map.fitBounds(L.latLngBounds(drawPolygon.allData.polygons.map((polygon) => polygon.getLatLngs())), {
        animate: true
      });
    }

    function addMarker(drawPolygon, map) {
      const coord = drawPolygon.relacao_campo.coordenadas;
      coord.latitude = MapaService.convertDMSToDD(coord.latitude);
      coord.longitude = MapaService.convertDMSToDD(coord.longitude);
      const marker = LeafletService.createMarker(
        [coord.latitude, coord.longitude],
        'images/marker-icons/icon_generico_branco.png'
      );
      const popup = createPopup(`Latitude: ${coord.latitude} <br> Longitude: ${coord.longitude}`);
      marker.bindPopup(popup);
      marker.addTo(map);
      vm.markers.push(marker);
    }

    function addPolygonPopup(polygon) {
      const popup = L.popup();
      polygon.bindPopup(popup);
      polygon.on('popupopen', () => {
        popup.setContent(createPopupContent(polygon));
      });
    }

    function hidePolygons(drawPolygon) {
      $scope.$emit('removePolygons', (drawPolygon.allData || {}).polygons || []);
      resetMarkers();

      drawPolygon.allData = null;
      drawPolygon.open = !drawPolygon.open;
      drawPolygon.color = drawPolygon.background;
      drawPolygon.background = null;
      $route.updateParams({
        activeDrawPolygon: null
      });
    }

    function resetMarkers() {
      const map = LeafletService.getMap('propriedade-map');

      if (!vm.markers) {
        return;
      }

      vm.markers.forEach((marker) => {
        map.removeLayer(marker);
        marker = null;
      });
    }

    function loadPolygonData(drawPolygon) {
      drawPolygon.loading = true;
      drawPolygon.allData = {};
      return DrawPolygonsService.get(drawPolygon.id).then((data) => {
        const dados = data.data;

        drawPolygon.allData = DrawPolygonsObjectService.convertToObject(dados || {}, true);
        return drawPolygon;
      });
    }

    function formatDescricaoHtml(drawPolygon) {
      const descricao = [];

      if (drawPolygon.gleba) {
        descricao.push(drawPolygon.gleba.descricao);
      }

      descricao.push(drawPolygon.descricao);

      if (drawPolygon.allData.atividade) {
        descricao.push(`Cultura: ${ drawPolygon.allData.atividade.descricao}`);
      }

      if (drawPolygon.allData.cultivar) {
        descricao.push(`Cultivar: ${ drawPolygon.allData.cultivar.descricao}`);
      }

      return descricao.join('<br>');
    }

    function generateTooltipContent(polygon) {
      const sorted = polygon.tipos_pragas && polygon.tipos_pragas.sort((a, b) => a.localeCompare(b));
      let ultimaPulverizacao = '';
      if (polygon.ultima_pulverizacao) {
        ultimaPulverizacao = `<br>Última pulverização: ${ $filter('date')(polygon.ultima_pulverizacao)}`;
      }

      return (polygon.descricao || polygon.gleba.descricao) +
              getArrayLabelContent(sorted, 'Tipos: ', '<br>') +
              getArrayLabelContent(polygon.hint, '', '<br>') +
             ultimaPulverizacao;
    }

    function getArrayLabelContent(value, title, separator) {
      value = value || [];
      if (!value.length) {
        return '';
      }

      value = value.map(function(item) {
        return $filter('humanize')(item);
      });

      return `<br>${ title }${value.join(separator || ', ')}`;
    }

    function createPopupContent(polygon) {
      return createPopup(TrackingService.getContentInfoWindow(polygon));
    }

    function createPopup(content) {
      return `<div class="simple-popup">
                ${content}
              </div>`;
    }

    function goToNew() {
      $scope.$emit('setPolygons', []);
      $scope.$emit('activateSidebar', 'drawPolygon', {});
    }

    function edit(drawPolygon, event) {
      if (event) {
        event.stopPropagation();
      }
      $scope.$emit('setPolygons', []);

      loadPolygonData(drawPolygon).then(() => $scope.$emit('activateSidebar', 'drawPolygon', drawPolygon));
    }

    function openUsosMaquina(maquinaId, date) {
      $uibModal.open({
        templateUrl: 'views/propriedade/usomaquinamodal.html',
        controller: 'UsoMaquinaCtrl',
        controllerAs: '$uso',
        resolve: {
          data: {
            maquinaId: maquinaId,
            date: date
          }
        }
      });
    }

    function toggleCarregarAutomaticamente($event, drawPolygon) {
      $event.stopPropagation();
      LoadingService.showLoading();

      DrawPolygonsService.toggleCarregarAutomaticamente(
        _.pick(drawPolygon, ['id', 'carregar_automaticamente'])
      )
        .then(() => drawPolygon.carregar_automaticamente = !drawPolygon.carregar_automaticamente)
        .then(LoadingService.hideLoading)
        .then(() => $scope.$emit('loadDefaultPolygons'))
        .catch(() => {
          LoadingService.hideLoading();
          MessagesService.alert('Não foi possível atualizar a demarcação.');
        });
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$root.initialize.then(() => {
      LoadingService.showLoading();
      reset();

      const selectedGleba = $routeParams.gleba || $routeParams.activeGleba;
      if (selectedGleba) {
        setFilterAttribute('gleba', $scope.$root.currentPropriedade.glebas.find((g) => g.id === +selectedGleba));
      }

      const promises = [
        AtividadesService.list(),
        DrawPolygonsService.tipos(),
        OperacoesService.getTipoOperacoesTodas(),
        MaquinasService.list({ simple: true }),
        loadCultivares()
      ];

      $q.all(promises).then(([atividades, tipos, operacoes, maquinas]) => {
        vm.atividades = atividades.data || [];
        vm.tipos = tipos.data || [];
        vm.operacoes = operacoes.data || [];
        vm.maquinas = maquinas.data || [];

        if (vm.currentGleba) {
          vm.filters.gleba = filterFilter(vm.glebas, { id: vm.currentGleba }, true)[0];
          vm.filters.atividade =
            filterFilter(vm.atividades, { descricao: vm.culturasPorGleba[vm.filters.gleba.id].descricao }, true)[0];
        }
        vm.filters.safra = filterFilter($scope.$root.safras, { current: true }, true)[0] || {};
        vm.initialized = true;
      })
        .catch(() => MessagesService.alert('Não foi possível buscar informações de Culturas e Cultivares.'))
        .finally(vm.getPolygons);
    });

    $scope.$on('$destroy', () => {
      $route.updateParams({
        activeDrawPolygon: null
      });
      resetMarkers();
      reset(false);
    });
  }
}());
